export default __webpack_public_path__ + "static/media/ASP.0c5ab849.png";